import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import avatar_default from 'assets/img/default-avatar.png';
import { useOidc } from '@axa-fr/react-oidc';
import { useTranslation } from 'react-i18next';
import PowerSettingsNew from '@mui/icons-material/PowerSettingsNew';
import { getOidcConfigName } from 'utils/functions';
import { root } from 'utils/auth/authConfig';
import {
  Avatar,
  Collapse,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuList,
  StyledMenuItem,
  StyledNavLinkMenu,
  StyledSelector,
  StyledArrowDropDown,
  StyledArrowDropUp
} from './UserMenuStyle';
import LanguageSelector from './LanguageSelector';
import { Tooltip } from "@mui/material";

const UserMenu = ({ drawerOpen, language, changeLanguage, userInfo }) => {
  const { t } = useTranslation();
  const [openAvatar, setOpenAvatar] = useState(false);
  const { logout } = useOidc(getOidcConfigName());

  const openCollapseAvatar = useCallback(
    e => {
      setOpenAvatar(!openAvatar);
      e.preventDefault();
    },
    [openAvatar]
  );

  const logoutAction = useCallback(
    e => {
      e.preventDefault();
      logout(root);
    },
    [logout]
  );

  const userName = userInfo?.firstName && userInfo?.lastName ? `${userInfo?.firstName} ${userInfo?.lastName}` : 'User';

  return (
    <List>
      <ListItem>
        <StyledNavLinkMenu to={'/'} onClick={openCollapseAvatar}>
          <ListItemIcon>
            <Avatar src={userInfo?.userAdditionalData?.avatar || avatar_default} alt='img' />
          </ListItemIcon>
          <Tooltip title={userName}>
          <ListItemText
            primary={userName}
            disableTypography={true}
            drawerOpen={drawerOpen}
          />
          </Tooltip>
          <ListItemIcon>
            {openAvatar ? <StyledArrowDropUp drawerOpen={drawerOpen} /> : <StyledArrowDropDown drawerOpen={drawerOpen} />}
          </ListItemIcon>
        </StyledNavLinkMenu>
        <Collapse in={openAvatar} unmountOnExit>
          <MenuList>
            {userInfo ? (
              <StyledMenuItem>
                <StyledNavLinkMenu to={'/'} onClick={logoutAction}>
                  <ListItemIcon>
                    <PowerSettingsNew />
                  </ListItemIcon>
                  <ListItemText primary={t('Tooltips.Logout')} disableTypography={true} drawerOpen={drawerOpen} />
                </StyledNavLinkMenu>
              </StyledMenuItem>
            ) : (
              ''
            )}
            <StyledSelector>
              <LanguageSelector language={language} changeLanguage={changeLanguage} drawerOpen={drawerOpen} />
            </StyledSelector>
          </MenuList>
        </Collapse>
      </ListItem>
    </List>
  );
};

UserMenu.propTypes = {
  changeLanguage: PropTypes.func.isRequired,
  language: PropTypes.string.isRequired,
  userInfo: PropTypes.object.isRequired,
  drawerOpen: PropTypes.bool
};

export default UserMenu;
